<template>
  <div>
    <div class="vant-like-pagination">
      <!-- 上一页按钮，使用 Vant 图标 -->
      <van-icon
        @click="prevPage"
        :disabled="page === 1"
        class="prev-button"
        :name="prevIconName"
      />

      <!-- 页码 -->
      <div class="page-numbers">
        <button
          v-for="pageNumber in visiblePages"
          :key="pageNumber"
          @click="goToPage(pageNumber)"
          class="page-number"
          :class="{ 'active': pageNumber === page }"
        >
          {{ pageNumber }}
        </button>
      </div>
      <!-- 下一页按钮，使用 Vant 图标 -->
      <van-icon
        @click="nextPage"
        :disabled="page === totalPages"
        class="next-button"
        :name="nextIconName"
      />
      <!-- 额外的图标作为页码 -->
      <div class="extra-page">
        <button
          @click="openPageSelector"
          class="page-number"
          :class="{ 'active': '1' === page }"
        >
          <van-icon class="your-icon-class" :name="yourIconName" />
        </button>
      </div>
    </div>
    <!-- 弹窗容器 -->
  <van-popup v-model="showPageSelector" position="bottom">
    <!-- Close button or icon -->
    <button @click="closePageSelector" class="close-button">
      <van-icon name="cross" /> <!-- You can change the icon to your preference -->
    </button>
    <div class="page-selector">
      <div class="page-list">
        <!-- 展示所有页码 -->
        <button
          v-for="pageNumber in totalPages"
          :key="pageNumber"
          @click="goToPageFromPopup(pageNumber)"
          class="page-number"
          :class="{ 'active': pageNumber === page }"
        >
          {{ pageNumber }}
        </button>
      </div>
    </div>
  </van-popup>
  </div>
</template>



<script>
export default {
  props: {
    currentPage: Number, // 当前页码
    totalPages: "", // 总页数
    onPageChange: Function, // 当页码变化时的回调函数
    visiblePageCount: {
      type: Number,
      default: 5, // 可见页码的数量
    },
  },
  watch: {
    currentPage(newPage) {
      this.page = newPage
      // 可以在这里触发你的自定义逻辑
    },
  },


  data() {
    return {
      page: this.currentPage,
      prevIconName: "arrow-left", // 上一页图标名称，根据 Vant 图标库的名称设置
      nextIconName: "arrow", // 下一页图标名称，根据 Vant 图标库的名称设置
      yourIconName: "guide-o",
      showPageSelector: false, // 控制弹窗显示隐藏
    };
  },
  computed: {
    visiblePages() {
      // 计算可见的页码范围
      const start = Math.max(1, this.page - Math.floor(this.visiblePageCount / 2));
      const end = Math.min(this.totalPages, start + this.visiblePageCount - 1);

      const visiblePages = [];
      for (let i = start; i <= end; i++) {
        visiblePages.push(i);
      }

      return visiblePages;
    },
  },
  methods: {
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.onPageChange(this.page);
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.onPageChange(this.page);
      }
    },
    goToPage(pageNumber) {
      this.page = pageNumber;
      this.onPageChange(this.page);
    },
    openPageSelector() {
      // 打开弹窗
      this.showPageSelector = true;
    },
    goToPageFromPopup(pageNumber) {
      // 点击弹窗中的页码进行跳转
      this.page = pageNumber;
      this.onPageChange(this.page);
      // 关闭弹窗
      this.showPageSelector = false;
    },
    jumpToPage() {
      // 从输入框中跳转页码
      const targetPage = parseInt(this.inputPage);
      if (!isNaN(targetPage) && targetPage >= 1 && targetPage <= this.totalPages) {
        this.page = targetPage;
        this.onPageChange(this.page);
        // 关闭弹窗
        this.showPageSelector = false;
      }
    },
    closePageSelector() {
      // Close the popup
      this.showPageSelector = false;
    },
 
  }
  
};
</script>

<style scoped>
/* 使用 Vant 分页的样式，可根据需要进一步自定义 */
.vant-like-pagination {
  position: fixed;
  bottom: 0; /* 将组件定位到底部 */
  left: 0; /* 可能需要根据需要调整左右位置 */
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #fff; /* 背景色，可根据需要自定义 */
  z-index: 999; /* 可能需要根据你的页面布局调整z-index值 */
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
}

.prev-button,
.next-button,
.page-number {
  display: flex; /* 使用Flex布局 */
  align-items: center; /* 垂直居中对齐 */
  justify-content: center; /* 水平居中对齐 */
  width: 35px; /* 固定宽度 */
  height: 35px; /* 固定高度 */
  padding: 0; /* 移除默认按钮内边距 */
  border: 1px solid #dcdfe6;
  background-color: #fff;
  font-size: 14px;
  color: rgb(238, 10, 36);
  border-radius: 50%;
  cursor: pointer;
  margin: 0 4px;
  transition: background-color 0.3s ease;
}

.prev-button:hover,
.next-button:hover,
.page-number:hover {
  background-color: #f0f9eb;
}

.prev-button:disabled,
.next-button:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.page-number.active {
  background-color: rgb(238, 10, 36);
  color: #fff;
}

.page-numbers {
  display: flex;
  align-items: center;
  flex-wrap: wrap; /* 允许页码按钮换行 */
}

/* 输入框和按钮水平对齐 */
.page-input {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
}

.page-input .van-field {
  margin-right: 8px; /* 调整输入框和按钮之间的间距 */
}

/* 弹窗容器样式 */
.page-selector {
  padding: 16px;
  background-color: #fff;
}

/* 弹窗中的页码按钮样式 */
.page-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.page-number {
  margin: 2px; /* 您可以根据需要调整边距值 */
}
.close-button {
  position: absolute;
  top: 8px; /* Adjust the top position as needed */
  right: 8px; /* Adjust the right position as needed */
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1000; /* Ensure it's above the popup content */
}

.close-button .van-icon {
  font-size: 16px; /* Adjust the font size as needed */
  color: #999; /* Color for the close icon */
}


</style>
